import { render, staticRenderFns } from "./SntDatePicker.vue?vue&type=template&id=747dc7d8&scoped=true&"
import script from "./SntDatePicker.vue?vue&type=script&lang=js&"
export * from "./SntDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747dc7d8",
  null
  
)

/* custom blocks */
import block0 from "./SntDatePicker.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports